const n="\n  pageInfo {\n    startCursor\n    endCursor\n    hasNextPage\n    hasPreviousPage\n  }\n";export{n as PAGE_INFO_FRAGMENT};
//# sourceMappingURL=page-info.js.map
